













































import { Component, Vue, Inject } from 'vue-property-decorator';
import Order from '../Order/Order.vue';
import Invoice from '../Invoice/Invoice.vue';
import { DocumentShowType } from './DocumentHeader.vue';

@Component
export default class LineHeader extends Vue {
  @Inject() public documentComponent!: Order | Invoice;
  @Inject() public documentShowType!: DocumentShowType;
}
